import { useAnstellungsverhaeltnisSchema } from '@/domain/mitarbeiter/features/anlageassistent/hooks/schema/useAnstellungsverhaeltnisSchema';
import { usePersonSchema } from '@/domain/mitarbeiter/features/anlageassistent/hooks/schema/usePersonSchema';
import { SubStepKey } from '@/domain/mitarbeiter/features/anlageassistent/types/types';
import z from 'zod';
import { useBezahlungSchema } from '@/domain/mitarbeiter/features/anlageassistent/hooks/schema/useBezahlungSchema';
import { useAbwesenheitenSchema } from '@/domain/mitarbeiter/features/anlageassistent/hooks/schema/useAbwesenheitenSchema';

export function useFormSchema() {
  const { PersoenlichesSchema, KontaktSchema, ArbeitsbereicheSchema } =
    usePersonSchema();
  const { anstellungSchema, FristenSchema } = useAnstellungsverhaeltnisSchema();
  const { BezahlungsartSchema, SollstundenSchema } = useBezahlungSchema();
  const { AbwesenheitenAllgemeinSchema } = useAbwesenheitenSchema();

  return z.object({
    person: z.object({
      persoenliches: PersoenlichesSchema,
      kontakt: KontaktSchema,
      arbeitsbereiche: ArbeitsbereicheSchema,
    }),
    anstellungsverhaeltnis: z.object({
      fristen: z.array(FristenSchema),
      anstellung: anstellungSchema,
    }),
    bezahlung: z.object({
      bezahlungsart: BezahlungsartSchema,
      sollstunden: SollstundenSchema,
    }),
    abwesenheiten: z.object({
      allgemein: AbwesenheitenAllgemeinSchema,
    }),
  });
}

export function useSubStepSchemasMap() {
  const formSchema = useFormSchema();

  return {
    'person.persoenliches': formSchema.shape.person.shape.persoenliches,
    'person.kontakt': formSchema.shape.person.shape.kontakt,
    'person.arbeitsbereiche': formSchema.shape.person.shape.arbeitsbereiche,
    'anstellungsverhaeltnis.anstellung':
      formSchema.shape.anstellungsverhaeltnis.shape.anstellung,
    'anstellungsverhaeltnis.fristen':
      formSchema.shape.anstellungsverhaeltnis.shape.fristen,
    'bezahlung.bezahlungsart': formSchema.shape.bezahlung.shape.bezahlungsart,
    'bezahlung.sollstunden': formSchema.shape.bezahlung.shape.sollstunden,
    'abwesenheiten.allgemein': formSchema.shape.abwesenheiten.shape.allgemein,
  } satisfies Record<SubStepKey, z.ZodTypeAny>;
}
